module.exports = __webpack_public_path__ + "static/media/tapan_profile.b49fc929.png";